// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The console tracker token.
 */
export const IConsoleTracker = new Token('@jupyterlab/console:IConsoleTracker', `A widget tracker for code consoles.
  Use this if you want to be able to iterate over and interact with code consoles
  created by the application.`);
/**
 * The Console cell executor token.
 */
export const IConsoleCellExecutor = new Token('@jupyterlab/console:IConsoleCellExecutor', `The console cell executor`);
//# sourceMappingURL=tokens.js.map